import * as d3 from "d3";
import AbstractForceGenerator from "./AbstractForceGenerator";

export default class RadialReactionGenerator extends AbstractForceGenerator {
    // Public:
    constructor(cParams) {
        super();
        this.saveParams(cParams);
        this.getOwnersGroups();
        this.createRadiusFunction();
        this.createStrengthFunction();
    }

    compute() {
        let strengthFunc = this._strengthFunc;
        let radiusFunc = this._radiusFunc;
        let slaveNode = this._slaveNode;
        let force = d3
            .forceRadial()
            .strength(strengthFunc)
            .radius(radiusFunc)
            .x(slaveNode.x)
            .y(slaveNode.y);
        return force;
    }

    // Private:
    saveParams(cParams) {
        this._strength = cParams.strength;
        this._slaveNode = cParams.slaveNode;
    }

    getOwnersGroups() {
        let slaveNode = this._slaveNode;
        let ownersGroups = slaveNode.group;
        let groups = [];
        for (let i = 0; i < ownersGroups.length; i++) {
            const group = ownersGroups[i];
            groups.push(group);
        }
        this._ownersGroups = groups;
    }

    createRadiusFunction() {
        let slaveNode = this._slaveNode;
        let getCommonCluster = d => this.getCommonCluster(d);
        let isOwner = d => this.isOwner(d);
        let func = function (d) {
            if (isOwner(d)) {
                let cluster = getCommonCluster(d);
                if (cluster) {
                    switch (slaveNode.category) {
                        case "solo":
                            return cluster.soloRadius;
                        case "cluster":
                            return cluster.clusterRadius;
                        case "shared":
                            return cluster.sharedRadius;
                        default:
                            console.error("Invalid node category.");
                            break;
                    }
                }
            }
            return 0;
        };
        this._radiusFunc = func;
    }

    createStrengthFunction() {
        let getCommonCluster = d => this.getCommonCluster(d);
        let isOwner = d => this.isOwner(d);
        let strength = this._strength;
        let func = function (d) {
            if (isOwner(d)) {
                let cluster = getCommonCluster(d);
                if (cluster) {
                    let nNodes = cluster.nodesIndices.length;
                    return strength / nNodes;
                }
                return 0
            } else {
                return 0;
            }
        };
        this._strengthFunc = func;
    }

    isOwner(d) {
        let ownersGroups = this._ownersGroups;
        if (d.type === "master") {
            let group = d.group[0];
            if (ownersGroups.indexOf(group) !== -1) return true;
        }
        return false;
    }

    getCommonCluster(masterNode) {
        const slaveClusters = this._slaveNode.clusters;
        const masterCluster = masterNode.clusters[0];
        const index = slaveClusters.indexOf(masterCluster);
        const itHasBeenFound = index !== -1;
        if (itHasBeenFound) {
            let cluster = slaveClusters[index];
            return cluster;
        } else {
            console.error("Not found common cluster.");
        }
    }
}